import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from '../../../components/Seo';

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { FooterFull } from '../../../components/FooterFull';

import {
  Screen1e,
  Offer,
  Revs,
  Reg,
  Advance,
} from '../../../components/LandingTemplates/kak_vyuchit_anglijskij_za_3_mesyaca';
import { Speakers } from '../../../components/LandingTemplates/kak_vyuchit_anglijskij_new';

const TITLE = 'Как выучить английский за 3 месяца — бесплатное занятие Advance';
const DESCRIPTION =
  'Занятие по технологиям эффективного изучения языков Николая Ягодкина, который посетили более 30 000 человек| Центр образовательных технологий Advance 🚀 Уникальные методики обучения ☝️ Заходите!';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget = <GetCourseWidget hash={'e5cd2c443eafdec5f97af9001fba2f39c53a18ff'} id={'142606'} /> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ color: '#353535' }}>
      <Screen1e widget={widget} />
      <Offer />
      <Revs />
      <Speakers />
      <Reg widget={widget} />
      <Advance />
    </main>

    <FooterFull />
  </DefaultLayout>
);
export default Page;
